import React from 'react';

export default function ProfileVerificationAlert() {
  return (
    <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 rounded-lg mb-6">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-semibold text-sm mb-1">🔒 Complete Your KYC Verification</h3>
          <p className="text-sm">
            Your profile is <strong>80%</strong> complete. Please verify your identity to gain full access to freelance jobs, payments, and investments.
          </p>
        </div>
        <button className="bg-yellow-500 hover:bg-yellow-600 text-white text-xs font-semibold px-3 py-1 rounded ml-4">
          Start KYC
        </button>
      </div>
    </div>
  );
}
